import React from 'react';

import { Fade, CircularProgress } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import { LoadingMLStyled } from './LoadingMLStyled';

const LoadingML = ({ loading, children, ...rest }) => {
  const theme = useTheme();
  return (
    <LoadingMLStyled theme={theme} loading={loading ? 1 : 0} {...rest}>
      <div className="backdrop">
        <Fade
          in={true}
          style={{
            transitionDelay: '0ms',
          }}
          unmountOnExit
        >
          <CircularProgress color="primary" />
        </Fade>
      </div>
      {children}
    </LoadingMLStyled>
  );
};

export default LoadingML;
